;(function () {
  'use strict';

  let angular = window.angular;

  DeviceFormController.$inject = [
    'Customer',
    'AppUtils'
  ];

  angular
    .module('app')
    .component('connectionDeviceRemove', {
      template:'<div ng-class="{transparent: ctrl.loading}"><div class="modal-header"><span translate>buttons.delete</span> <span translate>entities.device.modelName</span></div><div class="modal-body text-center"><div translate data-translate-values="{model: \'entities.device.modelName\', name: ctrl.device.name}">general._messages.remove</div></div><div ng-if="ctrl.removeDeviceError" class="alert alert-warning text-center marginB0 marginT10">{{ctrl.removeDeviceError}}</div><div class="modal-footer"><button class="btn btn-default pull-left" type="button" ng-click="ctrl.modalInstance.dismiss()" translate>buttons.cancel</button> <button class="btn btn-danger" type="button" ng-click="ctrl.removeDevice()" translate>buttons.delete</button></div></div><spinner css-class="\'small\'" show-logo="true" show="ctrl.loading"></spinner>',
      controller: DeviceFormController,
      controllerAs: 'ctrl',
      bindings: {
        modalInstance: '<',
        resolve: '<'
      }
    });

  function DeviceFormController (Customer, utils) {
    let vm = this;

    vm.$onInit = function onInit () {
      vm.device = vm.resolve.device;
      vm.customer = vm.resolve.customer;
      vm.removeDevice = removeDevice;
    };

    function removeDevice () {
      if (!vm.device) {
        return;
      }

      vm.loading = true;
      Customer.devices
        .destroyById({
          id: vm.customer.id,
          fk: vm.device.id
        })
        .$promise
        .then(() => {
          vm.loading = false;
          vm.modalInstance.close();
        })
        .catch(err => {
          vm.loading = false;
          vm.removeDeviceError = utils.getHTTPError(err);
        });
    }
  }
})();
